import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useHttp from "../../../../hooks/use-http";
import convertToExcel from "../../../../components/ExportToExcel";
import Pagination from "../../../../components/Pagination";
import { AutoComplete } from "antd";
import * as XLSX from "xlsx";
import moment from "moment";

const MaizeDataCaptureReport = () => {
  const frmRef = useRef({});
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/researchProgramMIS");
  };

  const [loading, setLoading] = useState(false);

  const [employeeId, setEmployeeId] = useState(0);
  const [employeeData, setEmployeeData] = useState([]);
  const [regionData, setRegionData] = useState([]);
  const [employeeAllData, setEmployeeAllData] = useState([]);
  const [regionId, setRegionId] = useState();
  const [stateName, setStateName] = useState();
  const [stateData, setStatedata] = useState([]);

  const [farmerNumber, setFarmerNumber] = useState("");

  const [farmerData, setFarmerData] = useState();

  const [showDateFilter, setShowDateFilter] = useState(false);

  const handleDateFilterChange = (e) => {
    setShowDateFilter(e.target.value === "Yes");
  };

  const [data, setData] = useState([]);

  const itemsPerPage = localStorage.getItem("pageSize") || 10;
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleFDateChange = (e) => {
    //console.log("handleFDateChange", e.target.value);
    setSelectedFromDate(e.target.value);
    setData([]);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
    setData([]);
  };

  // var date =date.setDate(date.getDate() + 10);

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 30);

  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);

  const toDate = new Date().toISOString().slice(0, 10);

  //console.log("toDate", toDate);

  const [selectedToDate, setSelectedToDate] = useState(toDate);

  const { sendRequest: getCropCutData } = useHttp();

  const fillCropCutData = async (
    employeeId,
    regionId,
    farmerNo,
    getType = ""
  ) => {
    var urlfilter = "";

    if (showDateFilter) {
      urlfilter = urlfilter + `&fromDate=${selectedFromDate}`;
      urlfilter = urlfilter + `&toDate=${selectedToDate}`;
    }

    if (employeeId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
    }

    if (regionId > 0) {
      urlfilter = urlfilter + `&regionId=${regionId}`;
    }
    if (farmerNo != "") {
      urlfilter = urlfilter + `&farmerNo=${farmerNo}`;
    }
    if (farmerNo != "") {
      urlfilter = urlfilter + `&stateName=${stateName}`;
    }

    if (getType != "") {
      urlfilter = urlfilter + `&getType=${getType}`;
    }

    if (
      stateName &&
      typeof stateName === "string" &&
      stateName.trim().length > 0
    ) {
      const sanitizedState = stateName.trim().replace(/[^a-zA-Z0-9_\- ]/g, "");
      urlfilter = urlfilter + `&stateName=${sanitizedState}`;
    }

    var url = `/api/agronomyRecordReport/?orgId=${localStorage.getItem(
      "orgId"
    )}&empId=${localStorage.getItem("empId")}${urlfilter} `;

    getCropCutData(
      {
        url: url,
      },
      (data) => {
        console.log("reportdata", data);
        if (getType == "Excel") {
          console.log("reportdata", data);
          // const handleDownload = async () => {
          //   const blob = await data.blob();
          //   const url = window.URL.createObjectURL(blob);
          //   const link = document.createElement('a');
          //   link.href = url;
          //   link.download = 'downloaded-file.csv'; // Set the file name here
          //   link.click();
          // }
        } else {
          console.log("reportdata", data);
          setData(data);
        }
      }
    );
  };

  const excelDownload = async (
    employeeId,
    regionId,
    farmerNo,
    getType = "Excel"
  ) => {
    setLoading(true);
    var urlfilter = "";

    if (showDateFilter) {
      urlfilter = urlfilter + `&fromDate=${selectedFromDate}`;
      urlfilter = urlfilter + `&toDate=${selectedToDate}`;
    }

    if (employeeId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
    }

    if (regionId > 0) {
      urlfilter = urlfilter + `&regionId=${regionId}`;
    }
    if (farmerNo != "") {
      urlfilter = urlfilter + `&farmerNo=${farmerNo}`;
    }

    if (getType != "") {
      urlfilter = urlfilter + `&getType=${getType}`;
    }

    if (
      stateName &&
      typeof stateName === "string" &&
      stateName.trim().length > 0
    ) {
      const sanitizedState = stateName.trim().replace(/[^a-zA-Z0-9_\- ]/g, "");
      urlfilter = urlfilter + `&stateName=${sanitizedState}`;
    }

    var url = `${
      process.env.REACT_APP_BASE_URL
    }/api/agronomyRecordReport/?orgId=${localStorage.getItem(
      "orgId"
    )}&empId=${localStorage.getItem("empId")}${urlfilter}`;

    try {
      const response = await fetch(url, {
        method: "GET",
        "Content-Type":
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        authorization: `Bearear ${localStorage.getItem("token")}`,
      });

      if (!response.ok) {
        console.error(`Error ${response.status}: ${response.statusText}`);
        setLoading(false);
      }

      const blob = await response.blob();

      const downloadUrl = window.URL.createObjectURL(blob);

      console.log(downloadUrl);

      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = "MaizeDataCaptureReport.xlsx";
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(downloadUrl);
      document.body.removeChild(link);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error downloading file:", error);
    }
  };

  useEffect(() => {
    fillCropCutData(0, 0, "");
  }, [getCropCutData]);

  const fieldsToExport = [
    "sno", // New: Serial number (you'll have to add this while mapping)
    "farmerFullName", // New: Concatenated full name
    "phoneNumber",
    "state",
    "farmLocation",
    "cropName",
    "variety",
    "cultiverPlantingRatio",
    "sowingMethod", // New field
    "femaleRowPlantingDate",
    "m1PlantingDate",
    "preEmergenceHerbicideDate",
    "m2PlantingDate",
    "npkFertilizerDate",
    "plantDensity", // New field
    "spacing", // New field
    "asi",
    "hybridRatio", // New field
    "thinningDate",
    "postEmergenceHerbicideDate",
    "ureaApplicationDate",
    "firstTasselingDate",
    "firstSilkingDate",
    "pollenShedDateM1",
    "silkingDateF",
    "asi", // Duplicate but needed per your list
    "deTasselingDate",
    "daysToMaturity",
    "rogueingDateM1M2",
    "hybridCobsHarvestingDate",
    "harvestMethod", // New field
    "farmSizeHa",
    "qtyHarvestedBags",
    "qtyAfterThreshingBags",
    "qtyRejectsBags",
    "totalYieldMt",
    "yieldPerHaMt",
    "latitude",
    "longitude",
    "user",
  ];

  const customHeaders = [
    "S.No",
    "Farmer's Name",
    "Phone Number",
    "State",
    "Farm Location",
    "Crop",
    "Variety",
    "Cultiver Planting ratio",
    "Sowing Method",
    "Planting date of female row (F)",
    "Planting date of 1st male rows (M1)",
    "Pre-emergence herbicide application Date",
    "Planting date of 2nd male rows (M2)",
    "Date of NPK fertilizer Application",
    "Plant Density",
    "Spacing",
    "ASI",
    "Hybrid Ratio",
    "Date of thinning the plants",
    "Post-emergence herbicide application date",
    "Urea application date",
    "Date of first tasseling",
    "Date of first silking",
    "Date of 50% pollen shed (Anthesis) (M1)",
    "Date of 50% silking (F)",
    "Anthesis Silking Interval (ASI)",
    "Date of De-tasseling female plants",
    "Days to maturity",
    "Rogueing of male rows (M1 & M2)",
    "Harvesting date of hybrid cobs (F)",
    "Harvest Method",
    "Farm Size(Ha)",
    "Qty harvested (bags)",
    "Qty After Threshing & winnowing (bags)",
    "Qty of Rejects (bags)",
    "Yield(kg)",
    "Yield (M/ha)",
    "Latitude",
    "Longitude",
    "User",
  ];

  const handleExportExcel = () => {
    const filename = "MaizeDataCaptureReport.xlsx";

    const processedData = data.map((item) => {
      const coordinates = JSON.parse(item.plotCoordinates || "[]");
      const latitude = coordinates.map((coord) => coord.latitude).join(", ");
      const longitude = coordinates.map((coord) => coord.longitude).join(", ");
      return {
        ...item,
        latitude,
        longitude,
      };
    });

    convertToExcel(processedData, fieldsToExport, filename, customHeaders);
  };

  const { sendRequest: getEmp } = useHttp();

  const EmployeeDetail = (state) => {
    var urlfilter = "";

    if (state && typeof state === "string" && state.trim().length > 0) {
      const sanitizedState = state.trim().replace(/[^a-zA-Z0-9_\- ]/g, "");
      urlfilter = urlfilter + `&stateName=${sanitizedState}`;
    }
    getEmp(
      {
        url: `/api/employeeListForProcReort/?useCase=Procurement&empId=${localStorage.getItem(
          "empId"
        )}&orgId=${localStorage.getItem("orgId")}${urlfilter} `,
      },
      (data) => {
        console.log("emp", data);
        var emplist = data;

        setEmployeeData(emplist);
        setEmployeeAllData(emplist);
      }
    );
  };

  useEffect(() => {
    EmployeeDetail(0);
  }, [getEmp]);

  const { sendRequest: getStateData } = useHttp();
  useEffect(() => {
    getStateData(
      {
        url: `/api/stateLocation/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        console.log("state", data);

        setStatedata(data);
      }
    );
  }, [getStateData]);

  const { sendRequest: getRegion } = useHttp();
  useEffect(() => {
    getRegion(
      {
        url: `/api/procurementRegionList/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        //console.log("region", data);

        setRegionData(data.data);
      }
    );
  }, [getRegion]);

  const { sendRequest: getFarmerNumber } = useHttp();
  useEffect(() => {
    getFarmerNumber(
      {
        url: `/api/farmerNumberList/?orgId=${localStorage.getItem(
          "orgId"
        )}&empId=${localStorage.getItem(
          "empId"
        )}&fieldExecutiveId=${employeeId}}&stateName=${stateName}`,
      },
      (data) => {
        // console.log("farmerNumberList", data);

        setFarmerData(data);
      }
    );
  }, [employeeId,stateName]);

  const handleSearch = (value) => {
    setFarmerNumber(value);
    setData([]);
  };

  // const options = farmerData&&farmerData.map(item => ({ value: item.identificationNo }));

  const filteredOptions =
    farmerData &&
    farmerData
      .filter((item) => item.farmerNo.includes(farmerNumber))
      .map((item) => ({ value: item.farmerNo }));

  //console.log(filteredOptions);

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-md-8 mt-3">
            <label className="card-title">Maize Data Capture Report</label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <br />
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label>State</label>
                  <select
                    id="stateName"
                    className="form-control"
                    ref={(el) => (frmRef.current["stateName"] = el)}
                    value={stateName}
                    onChange={(e) => {
                      var sName = "";

                      if (e.target.value != "--Select--") {
                        sName = e.target.value;
                        console.log("sName", sName);
                      }
                      setStateName(sName);
                      EmployeeDetail(sName);
                      setData([]);
                      setEmployeeId(0);
                    }}
                  >
                    <option value="">Select</option>
                    {stateData &&
                      stateData.map((x) => (
                        <option
                          key={x.stateName}
                          user-id={x.stateName}
                          value={x.stateName}
                        >
                          {x.stateName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor={"executive_officer"}>
                    {"Procurement Officer"}
                  </label>
                  <select
                    id="emp_id"
                    className="form-control"
                    ref={(el) => (frmRef.current["emp_id"] = el)}
                    value={employeeId}
                    onChange={(e) => {
                      var userid = 0;
                      if (e.target.value != "--Select--")
                        userid = e.target.value;

                      setEmployeeId(userid);
                      setData([]);
                    }}
                  >
                    <option value="0">Select</option>
                    {employeeData &&
                      employeeData.map((x) => (
                        <option
                          key={x.userId}
                          user-id={x.userId}
                          value={x.userId}
                        >
                          {x.employeeName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <label htmlFor="farmer_number">Farmer Number</label>
                <AutoComplete
                  className="form-control"
                  style={{ height: "30px" }}
                  value={farmerNumber}
                  options={filteredOptions}
                  placeholder="Farmer Number"
                  onChange={handleSearch}
                />
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  {" "}
                  <label htmlFor={"date_filter"}>{"Apply Date Filter"}</label>
                  <select
                    id="date_filter"
                    className="form-control"
                    ref={(el) => (frmRef.current["date_filter"] = el)}
                    onChange={handleDateFilterChange}
                  >
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              </div>
              {showDateFilter && (
                <>
                  <div className="col-md-3">
                    <div className="form-group">
                      {" "}
                      <label htmlFor={"from_date"}>{"From Date"}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        // ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedFromDate}
                        onChange={handleFDateChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label htmlFor={"to_date"}>{"To Date"}</label>

                      <input
                        type={"date"}
                        id={"date"}
                        required
                        // ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedToDate}
                        onChange={handleTDateChange}
                      />
                    </div>
                  </div>
                </>
              )}
              <div className="col-md-3  text-right">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={(e) => {
                      fillCropCutData(employeeId, regionId, farmerNumber);
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <h5>Please select the parameters to get the desired result</h5>
          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button>

              {/* <button
                type="button"
                className="btn btn-sm btn-warning mx-3"
                onClick={(e) => {
                  excelDownload(employeeId, regionId, farmerNumber, "Excel");
                }}
                disabled={loading}
              > */}
              {/* {loading ? (
                  <>
                    <i className="fas fa-spinner fa-spin"></i>
                  </>
                ) : (
                  <>
                    <i className="fas fa-file-image"></i>
                  </>
                )} */}
              {/* </button> */}
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered table-responsive text-center table-sm">
                      <thead>
                        <tr className="table-header">
                          <th>S.No</th>
                          <th>Crop</th>
                          <th>Variety</th>
                          <th>Cultiver Planting ratio</th>
                          <th>Planting date of female row (F)</th>
                          <th>Planting date of 1st male rows (M1)</th>
                          <th>Pre-emergence herbicide application Date</th>
                          <th>Planting date of 2nd male rows (M2)</th>
                          <th>Date of NPK fertilizer Application</th>
                          <th>Date of thinning the plants</th>
                          <th>Post-emergence herbicide application date</th>
                          <th>Urea application date</th>
                          <th>Date of first tasseling</th>
                          <th>Date of first silking</th>
                          <th>Date of 50% pollen shed (Anthesis) (M1)</th>
                          <th>Date of 50% silking (F)</th>
                          <th>Anthesis Silking Interval (ASI)</th>
                          <th>Date of De-tasseling female plants</th>
                          <th>Days to maturity</th>
                          <th>Rogueing of male rows (M1 & M2)</th>
                          <th>Harvesting date of hybrid cobs (F)</th>
                          <th>Farm Size(Ha)</th>
                          <th>Qty harvested (bags)</th>
                          <th>Qty After Threshing & winnowing (bags)</th>
                          <th>Qty of Rejects (bags)</th>
                          <th>Yield/Ha (MT)</th>
                          <th>Total Yield (MT)</th>
                          <th>Phone Number</th>
                          <th>State</th>
                          <th>Farm Location</th>
                          <th>Latitude</th>
                          <th>Longitude</th>
                          <th>User</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i} className="tablerowview">
                                <td>{i + 1}</td>
                                <td>{itm.cropName || "NA"}</td>
                                <td>{itm.varietyName || "NA"}</td>
                                <td>{itm.cultiverPlantingRatio || "NA"}</td>
                                <td>{itm.plantingDateOfFemaleRowF || "NA"}</td>
                                <td>
                                  {itm.plantingDateOf1stmaleRowsM1 || "NA"}
                                </td>
                                <td>
                                  {itm.preEmergenceHerbicideApplicationDate ||
                                    "NA"}
                                </td>
                                <td>
                                  {itm.plantingDateOf2ndMaleRowsM2 || "NA"}
                                </td>
                                <td>
                                  {itm.dateOfNpkFertilizerApplication || "NA"}
                                </td>
                                <td>{itm.dateOfThinningThePlants || "NA"}</td>
                                <td>
                                  {itm.postEmergenceHerbicideApplicationDate ||
                                    "NA"}
                                </td>
                                <td>{itm.ureaApplicationDate || "NA"}</td>
                                <td>{itm.dateOfFirstTasseling || "NA"}</td>
                                <td>{itm.dateOfFirstSilking || "NA"}</td>
                                <td>
                                  {itm.dateOf50PercentagePollenSedAnthesisM1 ||
                                    "NA"}
                                </td>
                                <td>
                                  {itm.dateOf50PercentageSilkingF || "NA"}
                                </td>
                                <td>
                                  {itm.anthesisSilkingIntervalAsi || "NA"}
                                </td>
                                <td>
                                  {itm.dateOfdetasselingFemalePlants || "NA"}
                                </td>
                                <td>{itm.daysToMaturity || "NA"}</td>
                                <td>{itm.rogueingOfMaleRowsM1M2 || "NA"}</td>
                                <td>
                                  {itm.harvestingDateOfHybridCobsF || "NA"}
                                </td>
                                <td>{itm.farmSizeHa || "NA"}</td>
                                <td>{itm.qtyHarvestedBags || "NA"}</td>
                                <td>
                                  {itm.qtyAfterThreshingWinnowingBags || "NA"}
                                </td>
                                <td>{itm.qtyOfRejectsBags || "NA"}</td>
                                <td>{itm.yieldPerHaMT || "NA"}</td>
                                <td>{itm.totalYieldMT || "NA"}</td>
                                <td>{itm.phoneNumber || "NA"}</td>
                                <td>{itm.state || itm.lga || "NA"}</td>
                                <td>{itm.farmLocation || "NA"}</td>
                                <td>
                                  {itm.plotCoordinates &&
                                    JSON.parse(itm.plotCoordinates).map(
                                      (coord, index) => (
                                        <div key={index}>{coord.latitude}</div>
                                      )
                                    )}
                                </td>
                                <td>
                                  {itm.plotCoordinates &&
                                    JSON.parse(itm.plotCoordinates).map(
                                      (coord, index) => (
                                        <div key={index}>{coord.longitude}</div>
                                      )
                                    )}
                                </td>
                                <td>
                                  {itm.executiveName || itm.createdBy || "NA"}
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default MaizeDataCaptureReport;
